export default "__VITE_ASSET__CPu2yYv2__"